module.exports = __webpack_public_path__ + "static/img/user.d11a452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/users/user.png
// module id = 4+62
// module chunks = 1